<template>
  <div
    class="rating-stars-container d-flex"
  >
    <div
      v-for="currentStarIndex in starCount"
      :key="currentStarIndex"
      class="star-icon unfilled"
      :class="{
        'cursor-pointer': isRatingEnabled,
        'filter': (isRatingEnabled && currentStarIndex <= latestHoveredStarIndex) || currentStarIndex <= frontStarCount,
      }"
      @mouseenter="hoverOnRatingStar(currentStarIndex)"
      @mouseleave="latestHoveredStarIndex = latestStarClicked"
      @click="rateClicked"
    />
    <div class="filled-stars-container d-flex">
      <div
        v-for="currentFilledStarIndex in frontStarCount"
        :key="currentFilledStarIndex"
        :class="{'last-star': currentFilledStarIndex === frontStarCount}"
        :style="{'width': getLastStarWidth(currentFilledStarIndex)}"
      >
        <div
          v-if="!isRatingEnabled || (isRatingEnabled && currentFilledStarIndex <= latestHoveredStarIndex)"
          class="star-icon filled"
        />
      </div>
    </div>
    <div
      v-if="!isRatingEnabled && isRateNumVisible"
      class="rate-number"
    >
      / {{ rating }}
    </div>
    <div v-if="isReviewCountVisible" class="d-none d-xl-inline-block rate-number">
      ({{ reviewCount }})
    </div>
  </div>
</template>

<script>
export default {
  name: 'RatingStars',
  props: {
    /**
     * termék jelenlegi értékelése
     *
     * nem kötelező, mert amikor akarunk értékelni akkor nem kell neki szám
     */
    rating: {
      type: Number,
      default: 0,
    },
    /**
     * értékelés engedélyezve van-e
     */
    isRatingEnabled: {
      type: Boolean,
      default: false,
    },
    /**
     * értékelés számának kijelzése engedélyezve van-e
     */
    isRateNumVisible: {
      type: Boolean,
      default: true,
    },
    /**
     * legutobb kattintott csillag száma
     */
    latestStarClicked: {
      type: Number,
      default: 0,
    },
    /**
     * termék jelenlegi értékelések száma
     */
    reviewCount: {
      type: Number,
      default: 0,
    },
    /**
     * termék jelenlegi értékelések száma megjelenik-e
     */
    isReviewCountVisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      /**
       * összes csillag száma
       */
      starCount: 5,
      /**
       * leugotbb hoverelt csillag indexe
       */
      latestHoveredStarIndex: 0,
    }
  },
  computed: {
    /**
     * szükséges szines csillagok száma
     */
    frontStarCount() {
      return this.isRatingEnabled ? 5 : Math.floor(this.rating) + 1
    },
    /**
     * kis kijelző-e
     *
     * @return {boolean}
     */
    isSmallScreen() {
      return this.$mq === 'sm'
    },
  },
  methods: {
    /**
     * kattintottunk a csillagon, ha engedélyezve van akkor kiküldük az eventet
     */
    rateClicked() {
      if (!this.isRatingEnabled) {
        return
      }
      this.$emit('rateClicked', this.latestHoveredStarIndex)
    },
    /**
     * utolsó csillag szélessége rating % alapján px-ben stringként
     *
     * @param currentFrontStar
     * @return {string|string}
     */
    getLastStarWidth(currentFrontStar) {
      if (this.isRatingEnabled) {
        return this.isSmallScreen ? '10px' : '15px'
      }
      const multiplier = currentFrontStar === this.frontStarCount ? (this.rating - Math.floor(this.rating)) : 1
      return (multiplier * (this.isSmallScreen ? 10 : 15)) + 'px'
    },
    /**
     * hover az egyik csillag felett, beirjuk, hogy azon állunk
     *
     * @param starIndex
     */
    hoverOnRatingStar(starIndex) {
      this.latestHoveredStarIndex = starIndex
    },
  },
}
</script>

<style lang="scss" scoped>
.rating-stars-container {
  position: relative;

  .rate-number {
    font-size: 14px;
    line-height: 16px;
    margin-left: 5px;
    color: var(--rating-star-rate-number-color);
    font-weight: 500;
  }

  .filled-stars-container {
    position: absolute;
    top: 0;
    left: 0;
  }

  .star-icon {
    width: 15px;
    height: 15px;
    background-image: var(--rating-star-icon-url);
    background-size: 15px;
    background-position: center;
    background-repeat: no-repeat;

    @media screen and (max-width: 576px) {
      background-size: 10px;
      width: 10px;
      height: 10px;
    }

    &.unfilled {
      z-index: 1;
      filter: var(--rating-star-unfilled-svg-filter);
    }

    &.filled {
      background-image: var(--rating-star-filled-icon-url);
      filter: var(--rating-star-filled-svg-filter);
    }
  }

  .last-star {
    overflow: hidden;
  }
}
</style>
